var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgContact(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 861.344,
    height: 648.679,
    viewBox: "0 0 861.344 648.679",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_7",
    "data-name": "Group 7",
    transform: "translate(0 0.001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73",
    "data-name": "Path 73",
    d: "M487.967,298.314c37.1-23.943,88.2-14.64,124.348,10.729a196.929,196.929,0,0,1,32.307,28.827c5.643,6.19,10.993,12.687,16.11,19.409,1.261,1.649,2.515,3.315,3.746,5q1.263,1.706,2.5,3.435c10.378,14.425,19.892,29.6,29.206,44.638,23.251,37.538,47.108,76.194,82.534,102.549,7.3,5.428,17.482,10.317,24.96,5.133,6.489-4.5,6.767-13.967,5.29-21.724-5.49-28.74-25.3-52.557-46.336-72.888s-44.332-38.971-60.23-63.537-23.161-57.364-9.236-83.094c12-22.173,37.821-34.61,63.024-35.189s49.685,9.222,71.007,22.673,40.066,30.531,59.631,46.43c11.794,9.592,28.261,19.109,41.114,10.988,10.856-6.863,11.7-23.338,5.233-34.431s-18.018-18.064-29.089-24.566Q852.533,232.4,800.973,202.121c-10.545-6.189-21.321-12.575-29.105-22.012s-12.108-22.686-7.817-34.139c4.234-11.286,16.059-18.453,28.023-19.948s24.015,1.823,35.2,6.314c41.912,16.832,140.6,126.951,166.9,145.778,16.9,12.092,34.66,27.4,36.369,48.112,2.13,25.784-23.526,47.182-49.278,49.683s-50.7-8.687-73.71-20.524-46.486-24.887-72.309-26.53-54.8,12.161-60.917,37.3c-5.323,21.874,8.21,44.446,25.838,58.442,13.8,10.958,29.992,18.256,45.635,26.462,4.344,2.272,8.642,4.621,12.834,7.132a180.251,180.251,0,0,1,29.935,22.5,183.678,183.678,0,0,1,25.774,29.641,179.181,179.181,0,0,1,15.621,27.173q1.007,2.176,1.955,4.412c.6,1.426,1.179,2.869,1.729,4.328,7.18,18.913,9.977,40.107.8,57.763-9.149,17.608-28.965,28.034-48.753,29.48a89.8,89.8,0,0,1-33.791-4.464,137.237,137.237,0,0,1-23.13-9.941c-34.259-18.387-61.381-47.545-86.151-77.521s-48.083-61.534-77.482-86.977-66.237-44.69-105.12-44.4-78.965,23.978-90.008,61.258c-16.1-27.736-26.981-59.355-25.544-91.388S461.024,315.7,487.967,298.314Z",
    transform: "translate(-169.329 -125.66)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_47",
    "data-name": "Ellipse 47",
    cx: 4.272,
    cy: 4.272,
    r: 4.272,
    transform: "translate(465.215 267.745)",
    fill: "#b3ff17"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_48",
    "data-name": "Ellipse 48",
    cx: 6.605,
    cy: 6.605,
    r: 6.605,
    transform: "translate(301.894 269.187)",
    fill: "#c2a4ff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_49",
    "data-name": "Ellipse 49",
    cx: 2.44,
    cy: 2.44,
    r: 2.44,
    transform: "translate(783.425 219.077)",
    fill: "#c2a4ff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_50",
    "data-name": "Ellipse 50",
    cx: 2.44,
    cy: 2.44,
    r: 2.44,
    transform: "translate(734.049 87.922)",
    fill: "#c2a4ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74",
    "data-name": "Path 74",
    d: "M843.026,456.742a26.081,26.081,0,0,1,2.78-5.683c4.344,2.272,8.642,4.621,12.834,7.132a180.253,180.253,0,0,1,29.935,22.5,26.025,26.025,0,0,1-45.549-23.953Z",
    transform: "translate(-169.329 -125.66)",
    fill: "#c2a4ff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_51",
    "data-name": "Ellipse 51",
    cx: 2.496,
    cy: 2.496,
    r: 2.496,
    transform: "translate(359.978 246.672)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_52",
    "data-name": "Ellipse 52",
    cx: 2.496,
    cy: 2.496,
    r: 2.496,
    transform: "translate(665.754 62.017)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_53",
    "data-name": "Ellipse 53",
    cx: 2.496,
    cy: 2.496,
    r: 2.496,
    transform: "translate(643.282 17.561)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_54",
    "data-name": "Ellipse 54",
    cx: 2.496,
    cy: 2.496,
    r: 2.496,
    transform: "translate(820.007 183.274)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_55",
    "data-name": "Ellipse 55",
    cx: 2.496,
    cy: 2.496,
    r: 2.496,
    transform: "translate(688.908 186.86)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_56",
    "data-name": "Ellipse 56",
    cx: 2.496,
    cy: 2.496,
    r: 2.496,
    transform: "translate(619.339 424.91)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_57",
    "data-name": "Ellipse 57",
    cx: 2.496,
    cy: 2.496,
    r: 2.496,
    transform: "translate(540.912 190.794)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58",
    "data-name": "Ellipse 58",
    cx: 2.496,
    cy: 2.496,
    r: 2.496,
    transform: "translate(537.408 143.601)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75",
    "data-name": "Path 75",
    d: "M866.141,532.284c-3.706-.152-7.3-.17-10.77-.05-21.356.738-35.581,6.857-39.028,16.788s3.93,23.547,20.237,37.356q2.419,2.048,5.043,4.063a80.028,80.028,0,0,1,24.518-58.158Z",
    transform: "translate(-169.329 -125.66)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_76",
    "data-name": "Path 76",
    d: "M846.05,563.682a79.5,79.5,0,0,1,20.093-31.4q1.8-1.724,3.7-3.331a80.082,80.082,0,0,1,44.5-18.615A179.186,179.186,0,0,1,929.97,537.51q1.006,2.176,1.954,4.412c.6,1.426,1.179,2.869,1.729,4.328,7.18,18.913,9.977,40.107.8,57.763-9.149,17.608-28.965,28.034-48.753,29.48a89.8,89.8,0,0,1-33.791-4.464,79.9,79.9,0,0,1-10.131-34.06c-.1-1.507-.147-3.015-.161-4.53A79.686,79.686,0,0,1,846.05,563.682Z",
    transform: "translate(-169.329 -125.66)",
    fill: "#b3ff17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77",
    "data-name": "Path 77",
    d: "M813.016,547.869c4.009-11.551,19.006-18.35,42.236-19.154,4.648-.164,9.761,1.77,14.593.237,23.445-7.435,44.716-2.576,62.079,12.97.6,1.426,1.179,2.87,1.729,4.328-.231-.086-.464-.167-.7-.248-23.462-8.143-46.752-12.9-66.814-13.719-3.707-.149-8.129-2.294-10.77-.047-21.208,18.048-35.552,10.486-39.029,16.787-5.079,9.2,3.932,23.545,20.238,37.356q2.419,2.051,5.04,4.06c.015,1.515.063,3.023.161,4.53q-3.946-2.916-7.477-5.9C816.568,574.047,809.009,559.414,813.016,547.869Z",
    transform: "translate(-169.329 -125.66)",
    fill: "#e4e4e4"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_59",
    "data-name": "Ellipse 59",
    cx: 2.496,
    cy: 2.496,
    r: 2.496,
    transform: "translate(729.063 499.027)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_60",
    "data-name": "Ellipse 60",
    cx: 2.496,
    cy: 2.496,
    r: 2.496,
    transform: "translate(684.907 466.926)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_61",
    "data-name": "Ellipse 61",
    cx: 24.27,
    cy: 24.27,
    r: 24.27,
    transform: "translate(696.916 430.161)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78",
    "data-name": "Path 78",
    d: "M509.2,311.783c5.673.267,17.408,3.084,30.123,6.726S565.81,326.6,579.419,331q35.733,11.544,71.462,23.08,4.912,1.584,9.851,3.2c1.261,1.649,2.515,3.315,3.746,5-2.894-1.023-5.8-2.013-8.7-2.956-12.378-4.023-23.12-6.676-35.133-10.335-18.488-5.627-37.992-13.018-56.909-19.9S523.121,314.783,509.2,311.783Z",
    transform: "translate(-169.329 -125.66)",
    fill: "#f0f0f0",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79",
    "data-name": "Path 79",
    d: "M932.758,262.924l53.58,88.947L935.78,261.155a1.849,1.849,0,1,0-3.022,1.769Z",
    transform: "translate(-169.329 -125.66)",
    fill: "#f0f0f0",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_62",
    "data-name": "Ellipse 62",
    cx: 2.496,
    cy: 2.496,
    r: 2.496,
    transform: "translate(734.8 394.773)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_63",
    "data-name": "Ellipse 63",
    cx: 16,
    cy: 16,
    r: 16,
    transform: "translate(283.538 359.527)",
    fill: "#b3ff17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80",
    "data-name": "Path 80",
    d: "M459.388,492.4a11.44,11.44,0,0,1-7.314-15.945L423.1,447.935l20.662-4.408,24.344,27.761a11.5,11.5,0,0,1-8.72,21.115Z",
    transform: "translate(-169.329 -125.66)",
    fill: "#ebcebf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_81",
    "data-name": "Path 81",
    d: "M320.866,270.427l16.157,10.649,18.912,4.43s15,107.2,22.37,113.629,1.16,7.04,3.157,15.909,6.62,27.015,6.62,27.015c-44.9,27.829-85.006,31.227-119.226,4.575a8.052,8.052,0,0,1,3.765-9.367c5.786-3.594-6.764-17.675-2.028-20.495s-3.633-23.913-3.633-23.913l1.46-45.3-4.066-6.948,5.728-44.6,14.767-6.562,5.056-14.987Z",
    transform: "translate(-169.329 -125.66)",
    fill: "#b3ff17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_82",
    "data-name": "Path 82",
    d: "M327.867,274.187l26.641,8.872s29.47-3.112,30.665,40.758-4.3,67.412-4.3,67.412,61.3,123.278-5.1,86.868l-19.4-76.41-20-120Z",
    transform: "translate(-169.329 -125.66)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_83",
    "data-name": "Path 83",
    d: "M354.584,371.177l13.819-1.909s1.334,20.834,7.944,23.992,4.382,3.677,5.161,7.02-5.878,12.6-.642,14.907,51,60,51,60l27-25c-1.856-5.028-10.785-.937-11.345-6.267-.7-8.059-14.838-30.074-17.846-32.9s-1.819-7.8-3.378-14.484-.477-.486-3.075-11.628S385.415,317,384.191,306.71s-15.558-16.342-15.558-16.342l-11.142,2.6Z",
    transform: "translate(-169.329 -125.66)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_84",
    "data-name": "Path 84",
    d: "M68.581,616l16.264,4.27,24.213-60.7-24-6.3Z",
    fill: "#ebcebf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85",
    "data-name": "Path 85",
    d: "M232.881,758.474l50.014,13.133.166-.633A20.128,20.128,0,0,0,268.707,746.4h0l-7.315-9.33-18.866,2.455-4.366-1.146Z",
    transform: "translate(-169.329 -125.66)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_86",
    "data-name": "Path 86",
    d: "M151.957,628.165h16.814l8-64.861-24.818,0Z",
    fill: "#ebcebf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87",
    "data-name": "Path 87",
    d: "M320.693,771.367l51.71,0v-.654a20.128,20.128,0,0,0-20.125-20.126h0l-9.445-7.166-17.623,7.167h-4.514Z",
    transform: "translate(-169.329 -125.66)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_88",
    "data-name": "Path 88",
    d: "M279.227,443.444c-4.062,5.078-2.031,22.341-2.031,22.341s-7.109,55.853-4.062,60.93-2.031,9.14-5.078,16.248-6.093,24.372-6.093,24.372c-17.264,14.217-16.248,79.209-16.248,79.209l-6.093,57.884c2.031,6.093,30.465,7.109,34.527,6.093s43.666-144.2,43.666-144.2-2.031,138.108-2.031,144.2,27.419,3.047,33.512,3.047,44.682-248.8,44.682-248.8V450.552l-5.078-7.109S283.289,438.366,279.227,443.444Z",
    transform: "translate(-169.329 -125.66)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_89",
    "data-name": "Path 89",
    d: "M288.867,277.187l-24.938,15.889-12.062,10.111,16,102s-24.309,92.716,14,87,36.161-89.039,36.161-89.039Z",
    transform: "translate(-169.329 -125.66)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90",
    "data-name": "Path 90",
    d: "M322.235,422.083a11.44,11.44,0,0,1-16.544-5.833l-40.644.982,11.2-17.913,36.879,1.814a11.5,11.5,0,0,1,9.108,20.95Z",
    transform: "translate(-169.329 -125.66)",
    fill: "#ebcebf"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_64",
    "data-name": "Ellipse 64",
    cx: 32.119,
    cy: 32.119,
    r: 32.119,
    transform: "translate(100.511 73.496)",
    fill: "#ebcebf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91",
    "data-name": "Path 91",
    d: "M265.527,210.171c3.607-5.58,10.375-9.3,16.936-8.253a23.127,23.127,0,0,1,38.75-13.489,7.192,7.192,0,0,1,7.033-.7,14.829,14.829,0,0,1,5.714,4.586,33.28,33.28,0,0,1,4.657,33.857c.8-2.915-2.119-5.657-5.071-6.312s-6.048-.035-9.041-.461c-3.836-.546-7.285-2.771-11.127-3.272-3.229-.421-6.477.407-9.626,1.237s-6.388,1.676-9.622,1.292-7.4,11.872-7.344,20.5c.011,1.636-.326,3.736-1.925,4.083-1.969.427-3.11-2.29-4.983-3.03a3.467,3.467,0,0,0-4.252,2.261,5.652,5.652,0,0,0,1.079,5.061,16.7,16.7,0,0,0,4.049,3.513l-.772.642c-1.284,1.7-3.947,1.769-5.8.72a12.511,12.511,0,0,1-4.162-4.739c-3.423-5.694-6.426-11.76-7.634-18.293S261.92,215.751,265.527,210.171Z",
    transform: "translate(-169.329 -125.66)",
    fill: "#7b7055"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_92",
    "data-name": "Path 92",
    d: "M276.867,306.187l-14.433-12.369s-16.852,5.258-19.71,16.314c-22.491,28.759-34.6,62.346-37.857,100.055,29.364,11.09,65.319,15.024,104,16l-8-30-55-10Z",
    transform: "translate(-169.329 -125.66)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_95",
    "data-name": "Path 95",
    d: "M501.855,773.687H434.878a11.525,11.525,0,0,1-11.511-11.512V527.2a11.525,11.525,0,0,1,11.512-11.512h66.976A11.525,11.525,0,0,1,513.367,527.2V762.175a11.525,11.525,0,0,1-11.512,11.512Z",
    transform: "translate(-169.329 -125.66)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_96",
    "data-name": "Path 96",
    d: "M486.04,521.687H451.693a4.332,4.332,0,0,1-4.326-4.327V505.014a4.332,4.332,0,0,1,4.327-4.327H486.04a4.332,4.332,0,0,1,4.327,4.327V517.36a4.332,4.332,0,0,1-4.327,4.327Z",
    transform: "translate(-169.329 -125.66)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_97",
    "data-name": "Path 97",
    d: "M584.269,774.032l-413.75.307a1.191,1.191,0,1,1,0-2.381l413.75-.307a1.191,1.191,0,1,1,0,2.381Z",
    transform: "translate(-169.329 -125.66)",
    fill: "#cacaca"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContact);
export default __webpack_public_path__ + "static/media/contact.a0d42a5da4e6cad0c9eb1ec6deb9f536.svg";
export { ForwardRef as ReactComponent };